export const LOADING_START_EVENT = 'ifit:loading:start';
export const LOADING_STOP_EVENT = 'ifit:loading:stop';

const emitLoadingEvent = (eventName) => {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new CustomEvent(eventName));
};

export const emitLoadingStart = () => emitLoadingEvent(LOADING_START_EVENT);
export const emitLoadingStop = () => emitLoadingEvent(LOADING_STOP_EVENT);

export const installFetchLoadingInterceptor = () => {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function' || window.fetch.__ifitLoadingPatched) {
    return;
  }

  const originalFetch = window.fetch;

  const patchedFetch = (...args) => {
    emitLoadingStart();
    try {
      return originalFetch.apply(window, args).finally(() => {
        emitLoadingStop();
      });
    } catch (error) {
      emitLoadingStop();
      throw error;
    }
  };

  patchedFetch.__ifitLoadingPatched = true;
  patchedFetch.__ifitOriginalFetch = originalFetch;
  window.fetch = patchedFetch;
};
